import { render, staticRenderFns } from "./Gym.vue?vue&type=template&id=665440d5&scoped=true&"
import script from "./Gym.vue?vue&type=script&lang=js&"
export * from "./Gym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665440d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665440d5')) {
      api.createRecord('665440d5', component.options)
    } else {
      api.reload('665440d5', component.options)
    }
    module.hot.accept("./Gym.vue?vue&type=template&id=665440d5&scoped=true&", function () {
      api.rerender('665440d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Gym.vue"
export default component.exports